import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
/* src/app/layout.sidebar/view.scss: no such file or directory */`],
})
export class LayoutSidebarComponent implements OnInit {
    public headerSearch: string = "";
    public primaryNav: any[] = [
        { label: "Works", href: "/dashboard?tab=work", tab: "work" },
        { label: "Projects", href: "/dashboard?tab=project", tab: "project" },
        { label: "Materials", href: "/dashboard?tab=reference", tab: "reference" },
        { label: "Notes", href: "/dashboard?tab=memo", tab: "memo" },
        { label: "Archive", href: "/dashboard?tab=output", tab: "output" },
        { label: "About", href: "/members", path: "/members" },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.closeMobileMenu();
    }

    @HostListener('document:click')
    public clickout() {
        this.closeMobileMenu();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public get userInitial(): string {
        const name = this.service.auth.session?.name || this.service.auth.session?.email || "S";
        return name.charAt(0).toUpperCase();
    }

    public closeMobileMenu() {
        this.service.status.toggle('navbar', true);
    }

    public openMobileMenu(event?: Event) {
        if (event) event.stopPropagation();
        this.service.status.toggle('navbar', false);
    }

    public navClass(item: any) {
        const base = "text-[13px] font-medium transition";
        if (this.isNavActive(item)) return `${base} text-zinc-950`;
        return `${base} text-zinc-500 hover:text-zinc-950`;
    }

    public mobileNavClass(item: any) {
        const base = "flex h-10 items-center border-b border-zinc-100 text-[15px] font-medium transition";
        if (this.isNavActive(item)) return `${base} text-zinc-950`;
        return `${base} text-zinc-500 hover:text-zinc-950`;
    }

    public submitSearch(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        const query = this.headerSearch.trim();
        this.closeMobileMenu();
        if (this.isDashboardRoute()) {
            const nextUrl = query ? `/dashboard?q=${encodeURIComponent(query)}` : "/dashboard";
            history.replaceState({}, "", nextUrl);
            window.dispatchEvent(new CustomEvent("sirius-dashboard-search", { detail: { query } }));
            return;
        }
        if (query) {
            this.service.href(`/dashboard?q=${encodeURIComponent(query)}`);
            return;
        }
        this.service.href("/dashboard?search=1");
    }

    public openQuickAdd() {
        this.closeMobileMenu();
        if (this.isDashboardRoute()) {
            window.dispatchEvent(new CustomEvent("sirius-dashboard-quick-add", { detail: { type: "work" } }));
            return;
        }
        this.service.href("/dashboard?quick=work");
    }

    private isNavActive(item: any) {
        if (item.path) return location.pathname.indexOf(item.path) === 0;
        if (location.pathname.indexOf("/dashboard") !== 0) return false;
        const tab = new URLSearchParams(location.search).get("tab") || "";
        if (!tab && item.tab === "work") return true;
        return tab === item.tab;
    }

    private isDashboardRoute() {
        return location.pathname.indexOf("/dashboard") === 0;
    }
}

export default LayoutSidebarComponent;